export default __webpack_public_path__ + "static/media/headercrt.2339434f.jpg";